/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import t from "react";
const a = (o) => {
  const { children: e } = o;
  return /* @__PURE__ */ t.createElement("div", { className: "k-prompt-footer" }, /* @__PURE__ */ t.createElement("div", { className: "k-actions k-actions-start k-actions-horizontal k-prompt-actions" }, e));
};
export {
  a as AIPromptFooter
};
